import { BindAll } from 'lodash-decorators';
import React from 'react';
@BindAll()
export default class Feedback extends React.PureComponent<{}> {
  toXiaozhi() {
    let target = `${this.AppConfig.xiaozhi}/lcicsp/new-pc/lenovoit/?source=bpp_visitor`;
    const token = this.$Store.System.AccessToken;
    // if (token) {
    target += `&ticket=${token ? token : 'bpp_visitor'}`;
    //新增referer逻辑
    target += `&referer=${encodeURIComponent(window.location.href)}`;
    // }
    window.open(target);
  }

  render() {
    return (
      <div className="widget">
        <span className="widgetIcon" onClick={this.toXiaozhi}>
          <React.Icons.RobotOutlined />
        </span>
      </div>
    );
  }
}
